import {useEffect, useState} from 'react';
import {useFetchPostDataV2, setPath, setViewUrl} from './useFetchData'
import {useQueryParams} from './useLocationData'
import productDetailMapping from '../data/mapping/pages/productDetailMapping';
import productRelatedProductsMapping from '../data/mapping/components/productRelatedProductsMapping';
import productDetailMockData from '../data/productDetail.json';
import productDetailPageRequest from '../data/requests/productDetailPageRequest.json';
import relatedProductsRequest from '../data/requests/relatedProductsRequest.json';

const useProductDetailData = (pagePath) => {
  const queryKey = 'productDetailData' + pagePath;
  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const [productDetailQueryData, setProductDetailQueryData] = useState('');
  const requestBody = setPath(productDetailPageRequest, pagePath);
  const { isLoading, error, data } = useFetchPostDataV2( queryKey, requestBody, isMockData);

  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = productDetailMapping(data);
      setProductDetailQueryData((prevState) => ({
        ...prevState,
        hero: mappedData.hero,
        productId: mappedData.productID,
        viewRelatedProduct: mappedData.viewRelatedProduct
      }))
    }
  }, [data, isMockData])

  if (isMockData) {
    return {
      error: false,
      isLoading: false,
      productDetailQueryData: productDetailMockData
    };
  }

  return  {
    error,
    isLoading,
    productDetailQueryData
  };
}

const useRelatedProductsData = (productId, viewRelatedProduct) => {
  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const [relatedProductsQueryData, setRelatedProductsQueryData] = useState('');
  const requestBodyRelatedProducts = setViewUrl(relatedProductsRequest, {productId, viewRelatedProduct});
  const { isLoading, error, data } = useFetchPostDataV2(
    ['relatedProducts', productId],
    requestBodyRelatedProducts,
    isMockData,
    !!viewRelatedProduct);


  useEffect(() => {
    if (data && !isMockData) {
      const mappedData = productRelatedProductsMapping(JSON.parse(data['relatedProducts'].body), viewRelatedProduct.display);
      setRelatedProductsQueryData((prevState) => ({...prevState, gridCategory: mappedData}))
    }
  }, [data, isMockData, viewRelatedProduct])

  if (isMockData) {
    return {
      relatedProductsError: false,
      relatedProductsIsLoading: false,
      productDetailQueryData: productDetailMockData
    };
  }

  return  {
    relatedProductsError: error,
    relatedProductsIsLoading: isLoading,
    relatedProductsQueryData
  };
}

export {useProductDetailData, useRelatedProductsData};
